import React from 'react';
import "../../media/css/ShowSlot.css";
import {globalMaxTime, globalMinTime,WeekdaysShortname} from "../../Services/Constants.mjs";
import {ts2hhmm, ts2hmm, ts2y} from "../../Services/Conversions.mjs";
import {Col, Container, Row, UncontrolledTooltip} from "reactstrap";

const date2minutes = d => {
	if ( typeof d === 'string' ) d = new Date(d);
	return (60 * d.getHours() + d.getMinutes());
};

const timeRangeMin = date2minutes('2023-01-21 '+globalMinTime+":00");
const timeRangeMax = date2minutes('2023-01-21 '+globalMaxTime+":00");
const timeRangeWidth = timeRangeMax - timeRangeMin;

const email2name = ( e ) => (
	e ?
		e
		.replace(/@.*/,'')
		.replace(/\./g,' ')
		.split(' ')
		.map( x => x.replace(/^(.)(.*)/,(x,y,z)=> y.toUpperCase()+z))
		.join(' ') :
		""
);

const SlotChartItem = class extends React.Component {
	constructor(props) {
		super(props);
		const p = props.item;
		const pctStart = 100 * (date2minutes(p.tinizio) - timeRangeMin);
		const pctEnd = 100 * (date2minutes(p.tfine) - timeRangeMin);
		this.state = {
			left: String(pctStart/timeRangeWidth)+"%",
			width: String((pctEnd-pctStart)/timeRangeWidth)+"%",
			self: p.email === props.curEmail,
			current: (p.kprenotazione === props.curItem)
		};
		this.ref = React.createRef();
	}
	render() {
		const i = this.props.item;
		return(
			<>
				<div
					count={this.props.count}
					key={i.kprenotazione}
					className={
						(this.state.self ? "self" : "other") +
						( parseInt(i.kfrozen) ? " frozen" : "") +
						( this.state.current ? " current" : "")
					}
					style={{ left: this.state.left, width: this.state.width }}
					ref={this.ref}
				>
					<label key={'label'+i.kprenotazione}>
						{ this.state.self ? i.lofnome : email2name(i.email) }
					</label>
					<UncontrolledTooltip
						key={'ttip'+this.props.item.kprenotazione}
						target={this.ref}
					>
						{
							this.state.self ?
								i.lofnome :
								(
									<div className={"text-start"}>
										<div>Dalle { ts2hmm(i.tinizio)} alle {ts2hmm(i.tfine)}</div>
										<div>{ i.lofnome }</div>
										<div>{ i.email }</div>
									</div>
								)
						}
					</UncontrolledTooltip>
				</div>
			</>
		);
	}
}

const SlotChartRow = class extends React.Component {
	constructor(props) {
		super(props);
		const d = new Date(props.date);
		const tts = String(d.getFullYear()+'-'+String( d.getMonth() +1).padStart(2,'0')+'-'+String( d.getDate() ).padStart(2,'0'));
		const classList = [];
		if ( d.getDay() === 6 ) classList.push('saturday');
		if ( d.getDay() === 0 ) classList.push('sunday');
		if ( tts === props?.curDate ) classList.push('current');
		const cn = classList.join(' ');
		const items = (props.data||[]).filter( p => p.tinizio.startsWith(tts) );
		this.state = { cn: cn, items: items };
		this.uid = window.glob.generateUid();
		//console.log(d, this.state, props);
	}
	render() {
		const d = this.props.date;
		const items = this.state.items;
		return(
			<Row
				key={ d.toString() }
				className={ this.state.cn }
				count={ this.state.items.length || 1 }
			>
				<Col
					sm={2}
					key={"label"}
					className={"daylabel"}
					id={'SlowChartRowLabel'+this.uid}
				>
					{ WeekdaysShortname[ d.getDay() ] } { d.getDate()}/{d.getMonth() +1 }
					<UncontrolledTooltip
						target={'#SlowChartRowLabel'+this.uid}
						placement={"right"}
					>
						<div className={"text-start"}>
							{ items.length ?
								items.map( (i,idx) => (
									<div
										key={idx}
										style={{overflow:"hidden",whiteSpace:"nowrap"}}
									>
										{ ts2hhmm(i.tinizio) + "-" + ts2hhmm(i.tfine) + " " + i.lofnome }
									</div>
								)) :
								"Nessuna prenotazione"
							}
						</div>
					</UncontrolledTooltip>
				</Col>
				<Col sm={10} key={"chart"}>
					<div className={"daychart"}>
						{ items.map( (i,idx) => (
							<SlotChartItem
								key={i.kprenotazione}
								item={i}
								count={idx}
								{ ...this.props }
							/>
						)) }
					</div>
				</Col>
			</Row>
		);
	}
};

const SlotChart = class extends React.Component {
	constructor(props) {
		super(props);
		const dtstart = new Date(props.slot.dtstart+' 12:00:00');
		const dtend = new Date(props.slot.dtend+' 12:00:00');
		let d = new Date(dtstart);
		const dates = [];
		while ( d <= dtend ) {
			dates.push(new Date(d));
			d.setDate( d.getDate() + 1);
		}
		this.state = { dates: dates };
	}
	render() {
		return(
			<Container
				className={"table"}
				fluid={true}
				key={ this.props.curDate }
			>
				{ this.state.dates.map( d => <SlotChartRow key={d.toString()} date={d} {...this.props} /> )}
			</Container>
		);
	}
}

class ShowSlot extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			slotData: false,
			visible: typeof props?.visible === 'boolean' ? props.visible : ! (props?.deps && props.deps?.field),
			myPrefix: props?.globPrefix ? props?.globPrefix +'showslot' : window.glob.generateUid(),
			value: props?.value||props?.parent?.kslot
		};
		if ( props?.parent?.tinizio ) {
			this.state.curDate = props.parent.tinizio.replace(/ .*/,'');
		}
		if ( props?.parent?.kprenotazione ) this.state.curItem = props.parent.kprenotazione;
		this.loadSlot = this.loadSlot.bind(this);
		this.uid = "ShowSlot-"+window.glob.generateUid();
	};
	componentDidMount() {
		if ( this.props.globPrefix ) {
			const p = this.props.globPrefix;
			if ( this.props.deps?.field ) {
				window.glob.register(`${p}changed.${this.props.deps.field}`,(v)=> {
					const s = { visible: !! v, slotData: false, slot: v };
					this.setState(s);
				}, this.uid );
			} else {
				window.glob.register(`${p}changed.slot`,(v)=>{
					const s = { slotData: false };
					const k = v?.kslotprenotazione;
					s.value = k;
					s.visible = !!k;
					if ( this.state.value !== s.value || this.state.visible !== s.visible ) this.setState(s);
				},this.uid);
			}
			window.glob.register([`${p}changed.ente`,`${p}changed.of`],()=>{
				this.setState({ slotData: false });
			},this.uid);
		}
		window.glob.register('prenotazione.tsintervalchanged',(...args)=>{
			args.filter( x => (x?.name === 'date') ).forEach( x => {
				this.setState({ curDate: x.value });
			});
		})
		window.glob.register('prenotazione.values',(...args)=>{
			this.loadSlot();
		})
	};
	componentWillUnmount() {
		if ( this.props.globPrefix && this.props.deps ) {
			const p = this.props.globPrefix;
			if ( this.props.deps?.field ) {
				window.glob.unregister(`${p}changed.${this.props.deps.field}`,this.uid );
			} else {
				window.glob.unregister(`${p}changed.slot`,this.uid );
			}
		}
		window.glob.unregister(['prenotazione.tsintervalchanged','prenotazione.values'],this.uid);
	};
	loadSlot() {
		const apdata = window.glob.getStatus(this.props.globPrefix+'values');
		if ( ! (apdata?.lofanno ?? apdata?.of) ) {
			this.setState({ slotData: false });
			return;
		}
		window.glob.slot.full(this.state.value).then( (e)=>{
			if ( e ) {
				const out = { slot: e.slot };
				const d = e.data ? (Array.isArray(e.data) ? e.data : [] ) : [];
				const ac = apdata?.lofanno ?? apdata.of?.lannocorso ?? "";
				const lente = apdata.lente ?? apdata.ente?.lente;
				out.data = d.filter( c => (c.lofanno === ac && c.lente === lente));
				this.setState({ slotData: out, anno: ac });
			}
		});
	};
	render() {
		if ( ! this.state.visible ) return "";
		if ( ! this.state.slotData ) {
			if ( this.state.value ) setTimeout( ()=>{ this.loadSlot() }, 10 );
			return "";
		}
		const slot = this.state.slotData.slot;
		const data = this.state.slotData.data;
		return (
			<div id={this.uid} className={"ShowSlot"}>
				<h4
					id={this.uid+'Button'}
					className={"accordion-button chart-title"}
					onClick={ ()=>{
						document.getElementById(this.uid+'Button').classList.toggle('collapsed');
						document.getElementById(this.uid+'Panel').classList.toggle('collapsed');
					}}
				>
					{ slot.ldesc }
					<span>
						{ this.state.anno ? `${this.state.anno}, ` : '' }
						{ ts2y(slot.dtstart) }
					</span>
				</h4>
				<div id={this.uid+'Panel'}>
					<SlotChart
						slot={slot}
						data={data}
						curDate={ this.state.curDate }
						curItem={ this.state.curItem}
						curEmail={window.glob.getStatus('login')?.mail}
					/>
				</div>
			</div>
		);
	}
}

export default ShowSlot;